import { c as _c } from "react/compiler-runtime";
import { onClearTableSearch } from "@components/common/faro-table/faro-table-filter/filter-toolbar-quick-search";
import { Searchbar } from "@components/header/searchbar";
import { SEARCHBAR_CONFIG } from "@components/header/searchbar-utils";
import { IconButton, SearchIcon } from "@flat-ui";
import { INFO_BAR_TOP_SPACING } from "@components/common/info-bar/info-bar";
import { useRouteMatch } from "@hooks/use-route-match";
import { Box, Stack } from "@mui-wrapper";
import { useAppSelector } from "@store/store-helper";
import { searchSelector } from "@store/ui/ui-selector";
import { useRef, useState } from "react";
/**
 * The entities toolbar on small screens: the main action, then a single row of icon buttons with
 * the search field opening underneath, to leave as much height as possible to the list.
 */
export function EntitiesToolbarMobile(t0) {
  const $ = _c(29);
  const {
    topMargin,
    children,
    mobileAction,
    filterButton,
    sortActions,
    rowsLabel,
    exportComponent,
    shouldSkipValidation,
    hasRows
  } = t0;
  const routeIdentifier = useRouteMatch();
  const {
    debouncedSearchText
  } = useAppSelector(searchSelector);
  const searchRef = useRef(null);
  let t1;
  if ($[0] !== debouncedSearchText.length) {
    t1 = () => debouncedSearchText.length > 0;
    $[0] = debouncedSearchText.length;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [isSearchOpen, setIsSearchOpen] = useState(t1);
  const shouldShowSearch = SEARCHBAR_CONFIG[routeIdentifier].isSearchAllowed && (hasRows || isSearchOpen);
  const hasToolbarRow = Boolean(shouldShowSearch || filterButton || sortActions || rowsLabel || exportComponent);
  let t2;
  if ($[2] !== isSearchOpen) {
    t2 = function toggleSearch() {
      if (isSearchOpen) {
        onClearTableSearch.emit();
      } else {
        requestAnimationFrame(() => searchRef.current?.querySelector("input")?.focus());
      }
      setIsSearchOpen(!isSearchOpen);
    };
    $[2] = isSearchOpen;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const toggleSearch = t2;
  const isEmpty = !mobileAction && !hasToolbarRow && !isSearchOpen && !children;
  let t3;
  if ($[4] !== isEmpty || $[5] !== topMargin) {
    t3 = isEmpty ? {
      mt: topMargin === 0 ? 0 : INFO_BAR_TOP_SPACING
    } : {
      mt: topMargin,
      mb: "1.25rem",
      gap: 1
    };
    $[4] = isEmpty;
    $[5] = topMargin;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== exportComponent || $[8] !== filterButton || $[9] !== hasToolbarRow || $[10] !== isSearchOpen || $[11] !== rowsLabel || $[12] !== shouldShowSearch || $[13] !== sortActions || $[14] !== toggleSearch) {
    t4 = hasToolbarRow && <Stack direction="row" sx={{
      alignItems: "center",
      gap: 0.5
    }}>{shouldShowSearch && <IconButton size="s" aria-label="Search" aria-expanded={isSearchOpen} pressed={isSearchOpen} onClick={toggleSearch}><SearchIcon /></IconButton>}{filterButton}{sortActions}<Stack direction="row" sx={{
        alignItems: "center",
        gap: 2,
        ml: "auto"
      }}>{rowsLabel}{exportComponent}</Stack></Stack>;
    $[7] = exportComponent;
    $[8] = filterButton;
    $[9] = hasToolbarRow;
    $[10] = isSearchOpen;
    $[11] = rowsLabel;
    $[12] = shouldShowSearch;
    $[13] = sortActions;
    $[14] = toggleSearch;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const t5 = isSearchOpen ? "block" : "none";
  let t6;
  if ($[16] !== t5) {
    t6 = {
      display: t5
    };
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== shouldSkipValidation) {
    t7 = <Searchbar shouldFullWidth={true} shouldSkipValidation={shouldSkipValidation} />;
    $[18] = shouldSkipValidation;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t6 || $[21] !== t7) {
    t8 = <Box ref={searchRef} sx={t6}>{t7}</Box>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== children || $[24] !== mobileAction || $[25] !== t3 || $[26] !== t4 || $[27] !== t8) {
    t9 = <Stack sx={t3}>{mobileAction}{t4}{t8}{children}</Stack>;
    $[23] = children;
    $[24] = mobileAction;
    $[25] = t3;
    $[26] = t4;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
}